import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import {
  employerReceiptDownload,
  EmployerReceiptDownloadPayload
} from 'Services/employerReportsService'

import { QueryNames } from 'Hooks/api/queryNames'

import { AppNotification } from 'Utils/types/appNotification'

export const useDownloadEmployerReceipts = () =>
  useMutation(
    [QueryNames.EmployerReceiptsDownload],
    async (payload: EmployerReceiptDownloadPayload) => {
      const response = await employerReceiptDownload(payload)
      if (response.success) {
        toast.success(AppNotification.BenefitProgramReceiptDownloadSuccess)
      } else {
        toast.error(response.message || AppNotification.BenefitProgramReceiptDownloadFailure)
      }
    },
    {
      onError: () => {
        toast.error(AppNotification.BenefitProgramReceiptDownloadFailure)
        return undefined
      }
    }
  )
